// using module.exports here so gatsby-config can read it
module.exports = {
    builderAPIKey: '2e6366bbcbb545d9878bc0053b7e0022'
}